import { render, staticRenderFns } from "./Form3StyleOfProceeding.vue?vue&type=template&id=131b4c09&scoped=true"
import script from "./Form3StyleOfProceeding.vue?vue&type=script&lang=ts"
export * from "./Form3StyleOfProceeding.vue?vue&type=script&lang=ts"
import style0 from "./Form3StyleOfProceeding.vue?vue&type=style&index=0&id=131b4c09&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131b4c09",
  null
  
)

export default component.exports